import PropTypes from 'prop-types';
import { emptyString } from '../../../constants/missingDataPlaceholder';
import { xCircleIcon, checkCircleIcon, circleIcon } from '../../common/Icons/in-circle.icon';
import { isUndefined } from 'lodash';
import styles from './PasswordRequirement.module.scss';

function PasswordRequirements(props) {
  const { isPasswordBeingSet, isMissingRequirement } = props;
  const relevantClassName = (property) => {
    if (!isPasswordBeingSet || isUndefined(isMissingRequirement[property])) return emptyString;
    return isMissingRequirement[property] ? styles.invalid : styles.valid;
  };
  const relevantIcon = (property) => {
    if (!isPasswordBeingSet || isUndefined(isMissingRequirement[property])) return circleIcon;
    return isMissingRequirement[property] ? xCircleIcon : checkCircleIcon;
  };

  return (
    <div className={styles.passwordRequirements}>
      Your new password must:
      <ul>
        <li className={relevantClassName('specificConstantsRequirement')}>
          <span>{relevantIcon('specificConstantsRequirement')}</span>
          Not include your first name, last name, email, or phone number as part of your password.
        </li>
        <li className={relevantClassName('identicalLettersRequirement')}>
          <span>{relevantIcon('identicalLettersRequirement')}</span>Not include 3 consecutive identical letters in your
          password (e.g., AAA, bbb).
        </li>
        <li className={relevantClassName('passwordLengthRequirement')}>
          <span>{relevantIcon('passwordLengthRequirement')}</span>Contain minimum of 8 characters.
        </li>
        <li className={relevantClassName('specialCharactersRequirement')}>
          <span>{relevantIcon('specialCharactersRequirement')}</span>Contain at least one uppercase letter, one
          lowercase letter, one number, and one special character (e.g., @, #, $, etc.).
        </li>
        {isMissingRequirement.last4PasswordsRequirement && (
          <li className={relevantClassName('last4PasswordsRequirement')}>
            <span>{relevantIcon('last4PasswordsRequirement')}</span>Not be one of your last 4 passwords.
          </li>
        )}
      </ul>
    </div>
  );
}
export default PasswordRequirements;

PasswordRequirements.propTypes = {
  isPasswordBeingSet: PropTypes.number.isRequired,
  isMissingRequirement: PropTypes.shape({
    last4PasswordsRequirement: PropTypes.bool,
    identicalLettersRequirement: PropTypes.bool,
    specificConstantsRequirement: PropTypes.bool,
    passwordLengthRequirement: PropTypes.bool,
    specialCharactersRequirement: PropTypes.bool,
  }),
};
